import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=0027daf4&scoped=true"
var script = {}
import style0 from "./divider.vue?vue&type=style&index=0&id=0027daf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0027daf4",
  null
  
)

export default component.exports